module.exports = __webpack_public_path__ + "static/customers-83b0f2007b9bf2e367eb5fae9003ff0d.jpg";